import { LANGUAGE_COOKIE } from '@/config/lang'
import { RESTAURANT_COOKIE, USER_ID_COOKIE } from '@/constants/storage'
import { getCookie } from '@/utils/cookie'

/**
 * Три условия, без которых приложением пользоваться нельзя: язык, аккаунт
 * и точка получения. Каждое — отдельный шаг онбординга, поэтому проверяются
 * они по отдельности: клиент, у которого нет только адреса, начинает с карты,
 * а не с выбора языка заново.
 *
 * Читаем cookie напрямую, а не через сторы: проверка нужна в guard роутера,
 * который срабатывает раньше, чем страница успевает поднять состояние.
 */
export function hasLanguage(): boolean {
  return Boolean(getCookie(LANGUAGE_COOKIE))
}

export function hasAccount(): boolean {
  return Boolean(getCookie(USER_ID_COOKIE))
}

/** Ресторан выставляют оба сценария — и доставка, и самовывоз. */
export function hasPickPoint(): boolean {
  return Boolean(getCookie(RESTAURANT_COOKIE))
}

export function isOnboarded(): boolean {
  return hasLanguage() && hasAccount() && hasPickPoint()
}
